import React, { useEffect, useState } from "react";
import { Typography, Row, Table, Spin, message, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import SidebarLayout from "./SidebarLayout";
import { useHistory, useLocation } from "react-router-dom";
import { routes } from "../../routes/Routes";
import _BankerService from "../../modules/BankerService";
import ButtonComponent from "../../components/Button/Button";
import _commonService from "../../modules/commonService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import "../FirmAdmin/FirmAdminDashboard.scss";

const { Title } = Typography;

// Credit-facility drill-down for the Senior Private Banker Firms tab -- same table UI as
// FacilityDetailsForComplianceAdmin.js, but sourced from the BankerId-scoped
// GetSponserFacilityListByFirmId endpoint instead of the assignment-based (SponserUsers) one.
const FacilityDetailsForBanker = () => {
  const history = useHistory();
  const location = useLocation();
  const firmId = location?.state?.firmId;
  const companyName = location?.state?.companyName;
  const userId = localStorage.getItem("BankerId");

  const [loading, setLoading] = useState(false);
  const [facilityRows, setFacilityRows] = useState([]);

  useEffect(() => {
    if (!firmId) {
      history.push(routes.seniorBankerFirmDashboard.path);
      return;
    }
    getSponserFacilityListByFirmId();
  }, []);

  const getSponserFacilityListByFirmId = async () => {
    try {
      setLoading(true);
      const res = await _BankerService.getSponserFacilityListByFirmId(firmId, userId);
      if (res.data.IsSuccess) {
        setFacilityRows(res?.data?.Obj || []);
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onRowViewClick = (row) => {
    history.push({
      pathname: routes.complianceAdminSponserDetails.path,
      state: { sponserId: row.SponserId },
    });
  };

  const columns = [
    {
      title: "Credit Facility",
      dataIndex: "LoanProgrameTypeName",
      key: "LoanProgrameTypeName",
      render: (value, row) => (value ? (row.CreditFacilityName ? `${value} (${row.CreditFacilityName})` : value) : "N/A"),
    },
    {
      title: "Utilized / Remaining",
      key: "sizeOutstanding",
      render: (_, row) => (
        <span>
          Utilized: ${_commonService.formatNumberWithCommas(row.Utilized) || "N/A"}
          <br />
          Remaining: ${_commonService.formatNumberWithCommas(row.Remaining) || "N/A"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, row) => (
        <ButtonComponent
          text="View Details"
          icon={<RightOutlined />}
          onClick={() => onRowViewClick(row)}
        />
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <div className="firm-admin-dashboard">
          <Row gutter={[8, 8]} justify="space-between" align="middle" className="dashboard-header facility-details-header">
            <Title level={3} className="title">
              Facility Details
            </Title>

            <Button
              icon={<LeftOutlined />}
              className="add-btn"
              onClick={() => history.push(routes.seniorBankerFirmDashboard.path)}
            >
              Back
            </Button>
          </Row>

          <div className="card-section">
            {companyName && (
              <Title level={5} className="form-title">
                {companyName}
              </Title>
            )}
            <Table
              columns={columns}
              dataSource={facilityRows}
              rowKey="SponserId"
              pagination={false}
              className="transparent-table"
              locale={{ emptyText: "No Credit Facilities Found" }}
            />
          </div>
        </div>
      </SidebarLayout>
    </Spin>
  );
};

export default FacilityDetailsForBanker;
